// extracted by mini-css-extract-plugin
export default {"container":"ProductList_container__5ipk5","title":"ProductList_title__fCKYc"};